<dashboard-filter-bar
  [accountOptions]="accountOptions"
  [dateRanges]="dateRanges"
  [activeFilterCount]="activeFilterCount"
  (filtersChange)="onFiltersChange($event)"
  (cleared)="onFiltersCleared()">
</dashboard-filter-bar>

<app-dashboard-sla-due-date-filters
  [slaDueDateCounts]="taskDueDateCounts"
  [totalItems]="filteredTasks.length"
  [context]="'tasks'"
  [selectedIds]="dueDateFilterIds"
  (valueEmitted)="handleDueDateFiltersEmitted($event)">
</app-dashboard-sla-due-date-filters>

<div class="mrs-table-inner-container">
  <div class="tasks-header">
    <h2>My Tasks</h2>
    <div class="group-by-toggle">
      <span class="toggle-label">Group by Case</span>
      <mat-slide-toggle [(ngModel)]="groupByCase" color="primary"></mat-slide-toggle>
    </div>
    <mat-chip *ngIf="activeFilterCount > 0" disabled class="filter-count-badge">
      {{ activeFilterCount }} Filter{{ activeFilterCount === 1 ? '' : 's' }} Active
    </mat-chip>
  </div>

  <div class="tasks-table-wrapper">
    <uw-tasks-list
      [tasks]="filteredTasks"
      [displayMode]="'dashboard'"
      [groupByCase]="groupByCase"
      [currentUserId]="currentUserId"
      [loadAssignableUsers]="loadAssignableUsers"
      [paginatorRef]="paginatorRef"
      (taskReassigned)="onTaskReassigned($event)"
      (updateTask)="onUpdateTask($event)">
    </uw-tasks-list>
  </div>

  <div class="paginator-row" *ngIf="filteredTasks.length > 0">
    <mat-paginator
      #paginator
      [length]="itemCount"
      [pageIndex]="0"
      [pageSize]="10"
      appearance="fill"
      [pageSizeOptions]="[10, 25, 50, 100]">
    </mat-paginator>
  </div>
</div>
